import { Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, map, Observable } from 'rxjs';

import { AppUpdateService } from '@shure/cloud/device-management/shared/services';
import { DeviceReadonlyStateProvider } from '@shure/shared/angular/utils/device-readonly';

import { CdmDeviceUiApiService } from '../api/cdm-device-ui-api.service';

/**
 * Determines if the device is in a readonly state using the following rules:
 * 1. If the app is currently updating, it is readonly (as are all devices).
 * 2. If the device is proxied and is password-protected, it is readonly.
 */
@Injectable({ providedIn: 'root' })
export class CdmDeviceReadonlyStateProvider extends DeviceReadonlyStateProvider {
	private readonly readonly$ = toObservable(this.appUpdateService.isReadOnly);

	constructor(
		private readonly appUpdateService: AppUpdateService,
		private readonly cdmDeviceUiApi: CdmDeviceUiApiService
	) {
		super();
	}

	public isReadonly$(deviceId: string): Observable<boolean> {
		return combineLatest([this.cdmDeviceUiApi.getDevice$(deviceId), this.readonly$]).pipe(
			map(([device, isAppReadOnly]) => {
				if (isAppReadOnly) {
					return true;
				}

				return (
					!!device.features.proxyDevice?.deviceId &&
					!!device.features.authentication?.enabledButNotAuthenticated
				);
			})
		);
	}
}
